<template>
	<div class="full">
		<vxe-grid :loading="loading" ref="initinputinvoiceorderTable" v-if="list_gridOptions" v-bind="list_gridOptions" @toolbar-button-click="list_toolbarButtonClickEvent"></vxe-grid>
	</div>
</template>
<style scoped>

</style>
<script>
	import listMixins from '@_system/components/base/mixins/list/list.js'
	export default {
		mixins: [listMixins],
		props: {
			date: {
				default: () => {
					return null
				}
			},
		},
		data() {
			return {
				loading:false,
				step: 1,
				invoicedata:[],
				tab:[],
				goodsUids:[],
				currentrow:null,
				modal_model: true,
				modal_title: '生成亿企赢单据',
				modal_width: 1200,
				modal_height: 800,
				list_footerField:[
					{field:'price',toFixed:6},
					{field:'taxprice',toFixed:6},
					{field:'totalPrice',toFixed:6},
				]
			}
		},
		watch: {

		},
		computed: {
			device() {
				return window.systemMethods.device()
			}
		},
		created() {

		},
		mounted() {

		},
		methods: {
			sourcefile(row) {
				this.invoicedata = {
					invoiceNumber:row.invoiceNumber,
					customerId:row.customerId,
					invoiceId:row.invoiceId,
					orderId:row.orderId,
					orderPlant:row.orderPlant,
					invoiceType:1
				}
				this.tab = ['invoice','detail']
				this.$nextTick(()=>{
					this.$refs.invoiceConfig.modal_show()
				})
			},
			invoiceConfigHide(){
				this.customreload()
			},
			adjustamount(row){
				this.loading = true
				this.$api.invoice.adjustamount({
					customerId:row.customerId,
					date:new Date(this.date).getTime()/1000
				}).then(()=>{
					this.loading = false
					this.customreload()
					this.$message.success('操作成功')
				},()=>{
					this.loading = false
				})
			},
			createorder(row){
				this.$confirm('是否确认生成？').then(()=>{
					this.loading = true
					this.$api.invoice.createorderyqdzorder({
						data:row,
						totaldata:this.$refs.initinputinvoiceorderTable.getTableData().fullData,
						date:new Date(this.date).getTime()/1000
					}).then(()=>{
						this.loading = false
						this.customreload()
						this.$message.success('操作成功')
					},()=>{
						this.loading = false
					})
				})
			},
			deleteorder(row){
				this.$confirm('是否确认删除？').then(()=>{
					this.loading = true
					this.$api.invoice.deleteorderyqdzorder({
						data:row,
					}).then(()=>{
						this.loading = false
						this.customreload()
						this.$message.success('操作成功')
					},()=>{
						this.loading = false
					})
				})
			},
			list_beforeCreateGrid(gridOptions){
				gridOptions.columns = [{
						type: 'seq',
						title: '#',
						width:50
					},{
						field: 'customerName',
						title: '存货名称',
					},
					{
						field: 'price',
						title: '不含税金额',
					},
					{
						field: 'taxprice',
						title: '税额',
					},
					{
						field: 'totalPrice',
						title: '价税合计',
					},
					{
						field: 'yqdztotalPriceAndTax',
						title: '亿企赢价税合计',
					},
					{
						field: 'diff',
						title: '差额',
					},
					{
						field: 'XScode',
						title: '销售单',
					},
					{
						field: 'CKcode',
						title: '出库成本单',
					},
					{
						field: 'XStotalNoTaxAmount',
						title: '销售金额',
					},
					{
						field: 'CKtotalNoTaxAmount',
						title: '出库成本',
					},
					{
						field: 'profit',
						title: '毛利率',
					},
					{
						title: '操作',
						fixed: "right",
						align: 'center',
						width: 175,
						slots: {
							default: ({row}) => {
								return [
									<el-button type = "text" size = "mini" onClick = {() => {this.adjustamount(row)}}>金额矫正</el-button>,
									<el-button type = "text" size = "mini" onClick = {() => {this.createorder(row)}}>生成单据</el-button>,
									<el-button type = "text" size = "mini" onClick = {() => {this.deleteorder(row)}}>删除</el-button>
								]
							}
						}
					}
				]
				gridOptions.formConfig = false
			},
			list() {
				return new Promise((resolve) => {
					let date = new Date(this.date).getTime()
					if(date){
						this.$api.invoice.initoutputinvoiceorder({
							date: date / 1000,
							action: 'group'
						}).then((res) => {
							resolve(res)
						},()=>{
							resolve({
								list:[]
							})
							this.loading = false
						})
					}else{
						resolve({
							list:[]
						})
					}
				})
			},
			valid(){
				let data = this.$refs.initinputinvoiceorderTable.getTableData().fullData
				let cargoNameBuff = false
				for(let i =0 ;i<data.length;i++){
					if(!data[i].cargoName){
						cargoNameBuff = data[i]
						break;
					}
				}
				if(cargoNameBuff){
					this.$refs.initinputinvoiceorderTable.scrollToRow(cargoNameBuff)
				}
				return cargoNameBuff
			},
			submit() {

				//this.init()
			},
			reset() {
				//this.init()
			},
			customreload() {
				this.$refs.initinputinvoiceorderTable.commitProxy('query')
			},
		},
		components: {

		}
	}
</script>